let identifyingCode: number = 0;

// 获取验证码的计时器
const initCodeCount = () => {
  if (identifyingCode === 0) {
    identifyingCode = 60
    const timer = setInterval(() => {
      if (identifyingCode !== 0) {
        identifyingCode--
      } else {
        clearInterval(timer)
      }
    },1000)
  }
}

// 校验图片类型
const judgeImageType = (val: any) => {
  return /\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(val)
}

const getFormatDate = (timestamp: any, type: any) => {
  try {
    const newDate: any = new Date(timestamp);
    const _format = (format: any) => {
      const date: any = {
        'M+': newDate.getMonth() + 1,
        'd+': newDate.getDate(),
        'h+': newDate.getHours(),
        'm+': newDate.getMinutes(),
        's+': newDate.getSeconds(),
        'q+': Math.floor((newDate.getMonth() + 3) / 3),
        'S+': newDate.getMilliseconds()
      };
      if (/(y+)/i.test(format)) {
        format = format.replace(RegExp.$1, (newDate.getFullYear() + '').substr(4 - RegExp.$1.length));
      }
      for (const k in date) {
        if (new RegExp('(' + k + ')').test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length === 1
            ? date[k] : ('00' + date[k]).substr(('' + date[k]).length));
        }
      }
      return format;
    }
    return _format(type)
  } catch (error) {
    console.log(error)
  }
}

export {
  identifyingCode,
  initCodeCount,
  judgeImageType,
  getFormatDate
}

